import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, signal } from '@angular/core';
import { Analytics } from '@app/core/services/analytics/analytics.service';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class BigShortService {
  baseUrl: string = environment.apiUrl;

  isInitialized = signal(false);
  isBigShortChallengeActive = signal(false);
  staticBanners = signal<any[]>([]);

  constructor(
    private readonly http: HttpClient,
    private readonly injector: Injector
  ) {}

  private get analytics(): Analytics {
    return this.injector.get(Analytics);
  }

  initializeBigShortAndStaticBannerData(page: string): void {
    if (!this.isInitialized()) {
      this.http
        .get(`${this.baseUrl}/viewer/film/bigShortStaticBanner`)
        .subscribe({
          next: (res: any) => {
            this.isBigShortChallengeActive.set(
              res.data.bigShortChallenge === true ||
                res.data.bigShortChallenge === 'true'
            );
            this.staticBanners.set(res.data?.banners ?? []);
            this.isInitialized.set(true);
          },
          error: (error) => {
            this.analytics.failureEvent('Get BigShort Data Failure', {
              error: '/viewer/film/bigShortStaticBanner API Error',
              page,
              reason: error.error?.message ?? error?.message,
            });
            console.error('Error fetching BigShort data:', error);
          },
        });
    }
  }
}
